module.exports = __webpack_public_path__ + "static/media/invite_phone.00ac9b32.png";